import RootState from '@vue-storefront/core/types/RootState'
import { Module } from 'vuex'
import { DEFAULT_PAGE_SIZE } from '../constants'
import { CategoryReviewState } from '../types/CategoryReview'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export const categoryReviewStore: Module<CategoryReviewState, RootState> = {
  namespaced: true,
  state: {
    categoryId: null,
    items: [],
    totalCount: 0,
    averageRating: 0,
    currentPage: 1,
    pageSize: DEFAULT_PAGE_SIZE
  },
  actions,
  getters,
  mutations
}
